/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $GraphicsBox, getProp} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store} from '@gongxigames/framework/core';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {ResponsiveConf} from '@gongxigames/framework/core/fragments/display/responsive';
import {$ButtonRuby} from '../../../JSX/ButtonRuby';
import {computedFormatCents} from '../../../../../JSX/helpersFormat';
import {MainUiProps} from './UIDefault';
import {$PanelDisplay} from './PanelDisplay';
import {$BetSelect} from './BetSelect';
import {$SoundBtn} from './SoundBtn';
import {$TurboBtn} from './TurboBtn';
// import {$WinAreaPortrait} from './WinArea/WinAreaPortrait';

export const $ControlsPanelPortrait: FC<MainUiProps> = (props) => {
    const balance = computedFormatCents(props.balance);
    const panelHeight = 120;

    const controlsPosition = Store.computed<ResponsiveConf>(() => {
        const jZoneHeight = getProp(props.jurisdictionZoneHeight);

        return {
            box: {width: '100%', height: `${panelHeight}px`, y: '100%'},
            translate: {y: `${(jZoneHeight + panelHeight) * -1}px`}
        };
    });

    return <$GraphicsBox
        name='controls_panel_portrait'
        responsive={controlsPosition}
        responsiveBoxSize
        boxColor={0x000}
        boxAlpha={0.32}
        visible={slotStore.stage_isPortrait}
        {...props}
    >
        <$SoundBtn
            responsive={{box: {y: '50%', x: `${8*3+108/2}px`}}}
            action={props.onSoundBtn}
            soundEnabled={props.soundEnabled}
        />
        <$ButtonRuby
            icon='btn_icon_menu'
            bg='round_btn_bg'
            responsive={{box: {y: '50%', x: `${(8*3*2)+108*1.5}px`}}}
            action={props.onMenuBtn}
            hitArea='round'
        />
        <$BetSelect
            label='cashLabel'
            betFormatted={props.betFormatted}
            betCurrent={props.betCurrent}
            betList={props.betList}
            action={props.onBetChangeBtn}
            responsive={{
                box: {y: '50%', x: '50%'},
            }}
        />
        <$PanelDisplay
            label='cashLabel'
            value={balance}
            maxWidth={90*3}
            responsive={{
                box: {y: '50%', x: '100%'},
                translate: {x: `${-92*3/2}px`},
            }}
        />
        <$TurboBtn
            responsive={{
                box: {x: '100%', y: '-164px'},
                translate: {x: '-190px'},
            }}
            currentLevel={props.turboLevel}
            action={props.onTurboBtn}
        />
        {/* <$WinAreaPortrait/> */}
    </$GraphicsBox>;
};